<template>
  <div class="pi-cfilters" role="group" aria-label="Filtros da lista de empresas">
    <div v-if="showSearch" class="pi-cfilters__field pi-cfilters__search">
      <span class="pi-cfilters__label"><label class="pi-cfilters__text" :for="ids.search">Buscar empresa</label><pi-definition-tooltip class="pi-cfilters__info" info-key="filter.search" label="Buscar empresa"/></span>
      <input :id="ids.search" type="search" class="form-control pi-input" maxlength="60" placeholder="Nome ou id (2+ letras)"
             :value="state.search" @input="onSearch($event.target.value)" @keydown.enter.prevent="flushSearch">
    </div>
    <filter-select class="pi-cfilters__field" label="Faixa de ativos (30 dias)" :value="state.band" :options="bandOptions"
                   all-label="Todas" @input="set('band', $event)">
      <pi-definition-tooltip slot="info" class="pi-cfilters__info" info-key="filter.band" label="Faixa de ativos (30 dias)"/>
    </filter-select>
    <filter-select class="pi-cfilters__field" label="Jornada" :value="state.journey" :options="journeyOptions"
                   all-label="Todas" @input="set('journey', $event)">
      <pi-definition-tooltip slot="info" class="pi-cfilters__info" info-key="filter.journey" label="Jornada"/>
    </filter-select>
    <filter-select class="pi-cfilters__field" label="Contrato" :value="state.contract" :options="contractOptions"
                   all-label="Qualquer uso" @input="set('contract', $event)">
      <pi-definition-tooltip slot="info" class="pi-cfilters__info" info-key="filter.contract" label="Contrato"/>
    </filter-select>
    <filter-select v-if="showInternal" class="pi-cfilters__field" label="Demonstração" :value="state.internal" :options="internalOptions"
                   :all-label="internalHideLabel" @input="set('internal', $event)">
      <pi-definition-tooltip slot="info" class="pi-cfilters__info" info-key="filter.internal" label="Demonstração"/>
    </filter-select>
    <span class="pi-cfilters__labelled">
      <label class="pi-cfilters__check">
        <input type="checkbox" :checked="state.signal === dropKey" @change="set('signal', $event.target.checked ? dropKey : '')">
        Só com queda de atividade
      </label>
      <pi-definition-tooltip info-key="filter.signal" label="Só com queda de atividade"/>
    </span>
    <a v-if="active" href="#" class="pi-cfilters__clear" @click.prevent="clear">Limpar</a>
  </div>
</template>

<script>
import filterSelect from "../default/filterSelect.vue";
import piDefinitionTooltip from "./piDefinitionTooltip.vue";
import {
  BAND_OPTIONS, COMPANY_FILTER_DEFAULTS, CONTRACT_OPTIONS, INTERNAL_HIDE_LABEL, INTERNAL_OPTIONS, JOURNEY_OPTIONS, SIGNAL_DROP, cleanCompanyFilters,
  hasCompanyFilters,
} from "./piCompanyFilters.js";

const SEARCH_DELAY_MS = 350;

let sequence = 0;

export default {
  name: "pi-company-filters",
  components: { filterSelect, piDefinitionTooltip },
  props: {
    value: { type: Object, default: () => Object.assign({}, COMPANY_FILTER_DEFAULTS) },
    showSearch: { type: Boolean, default: true },
    showInternal: { type: Boolean, default: false },
  },
  data() {
    sequence += 1;
    return {
      ids: { search: "pi-cfilters-search-" + sequence },
      bandOptions: BAND_OPTIONS,
      journeyOptions: JOURNEY_OPTIONS,
      contractOptions: CONTRACT_OPTIONS,
      internalOptions: INTERNAL_OPTIONS,
      internalHideLabel: INTERNAL_HIDE_LABEL,
      dropKey: SIGNAL_DROP,
      typed: null,
      timer: null,
    };
  },
  computed: {
    state() {
      const clean = cleanCompanyFilters(this.value);
      if (this.typed !== null) clean.search = this.typed;
      return clean;
    },
    active() {
      return hasCompanyFilters(this.state);
    },
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    emit(next) {
      this.$emit("input", cleanCompanyFilters(next));
    },
    set(key, value) {
      const next = Object.assign({}, this.state);
      next[key] = value;
      this.emit(next);
    },
    onSearch(value) {
      this.typed = value;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.flushSearch, SEARCH_DELAY_MS);
    },
    flushSearch() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
      if (this.typed === null) return;
      const next = Object.assign({}, this.state, { search: this.typed });
      this.typed = null;
      this.emit(next);
    },
    clear() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
      this.typed = null;
      this.emit(COMPANY_FILTER_DEFAULTS);
    },
  },
};
</script>

<style scoped>
.pi-cfilters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px 14px;
  margin: 0 0 10px;
}

.pi-cfilters__field {
  min-width: 170px;
}

.pi-cfilters__search {
  min-width: 220px;
  margin: 0;
  font-weight: 400;
}

.pi-cfilters__label {
  display: block;
  font-size: 12px;
  color: #4b5563;
  margin-bottom: 2px;
}

.pi-cfilters__text {
  display: inline;
  margin: 0;
  font-weight: inherit;
}

.pi-cfilters__info {
  margin-left: 4px;
  vertical-align: middle;
}

.pi-cfilters__labelled {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 0 8px;
}

.pi-cfilters__labelled .pi-cfilters__check {
  margin: 0;
}

.pi-cfilters__check {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 400;
}

.pi-cfilters__clear {
  margin: 0 0 8px;
  font-size: 12px;
  color: #1b59f8;
}

@media (max-width: 767px) {
  .pi-cfilters__field,
  .pi-cfilters__search {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piCompanyFilters.vue